module.exports = __webpack_public_path__ + "img/02-11.f370c528.png";